
    import {Options, Prop, Vue} from 'vue-property-decorator';
    import {Tag} from '@/profile-creation-wizard/components/for-creation/Tag';
    import {TipsPart} from '@/profile-creation-wizard/components/for-creation/TipsPart';
    import {eventBusProfileCreationWizard} from '@/profile-creation-wizard/common/events';

    @Options({emit: ['select']})
    export default class TagSuggestion extends Vue {
        @Prop({type: Array, default: []})
        suggested!: Tag[];

        @Prop({type: Number, default: 7})
        visibleLimit;

        get limitedTags(): Tag[] {
            return this.suggested.filter((_, index) => index < this.visibleLimit);
        }

        get hasTag() {
            return !!this.suggested.length;
        }

        selectSkill(tag: Tag): void {
            this.$emit('select', tag);
            eventBusProfileCreationWizard.emit('creation:focus-changed', TipsPart.tags);
        }
    }
